/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KycCompanyFormDto } from '../../models/kyc-company-form-dto';

export interface UpdateCompanyForm$Params {
  processId: string;
      body: KycCompanyFormDto
}

export function updateCompanyForm(http: HttpClient, rootUrl: string, params: UpdateCompanyForm$Params, context?: HttpContext): Observable<StrictHttpResponse<KycCompanyFormDto>> {
  const rb = new RequestBuilder(rootUrl, updateCompanyForm.PATH, 'put');
  if (params) {
    rb.path('processId', params.processId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<KycCompanyFormDto>;
    })
  );
}

updateCompanyForm.PATH = '/kyc/processes/{processId}/company-form';
